// -*-mode: rjsx -*-
// REACT
// eslint-disable-next-line
import React, { useState, useEffect } from "react"
// eslint-disable-next-line
import clsx from "clsx"
// UTILS
import * as _ from "lodash"

// MUI
// eslint-disable-next-line
import { withStyles, createStyles, makeStyles } from "@material-ui/core/styles"
// eslint-disable-next-line
import Typography from "@material-ui/core/Typography"

// FLASH
// eslint-disable-next-line
import { globalStyles, useGlobalStyles } from "../FlashStyles.js"
// eslint-disable-next-line
import FlashSelectCard from "../Flash/FlashSelectCard.js"
import FlashSwipeItem from "../Flash/FlashSwipeItem.js"

// LOGGING SETUP
import appConfig from "./../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<FlashSelectList>")

const useDefaultStyles = makeStyles(theme => ({

    swipeItemDiv: {
        margin: 0 ,
        padding: 0,
        marginBottom: 0,
        borderRadius: 0,

        
        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
//            marginTop: 10,
//            marginBottom: 10,
        },
    },
}))

let FlashSelectList = (props) => {

    // eslint-disable-next-line
    const { className, statements: statementsProp, onChange } = props

    const [statements, setStatements] = useState(
        () => {
            if(statementsProp) return statementsProp
            else {
                return [
                    { uuid: "1",
	              txt: "Question will frighten many and will result in undercount",
                      isChecked: false,
                      rank: 0,
	            },
                    { uuid: "2",
	              txt: "Census helps define congressional districts - need to be based on citizens. More text going into another couple of lines. This is first extra sentence. This is second extra sentence.",
                      isChecked: false,
                      rank: 0,
	            },
                    { uuid: "3",
	              txt: "Illegals have been paying taxes & helping economy - need to be included",
                      isChecked: false,
                      rank: 0,
	            },
                    { uuid: "4",
	              txt: "Illegals won't want to answer anyway",
                      isChecked: false,
                      rank: 0,
	            },

                    { uuid: "5",
	              txt: "Citizenship question was used in past - just removed in 2010",
                      isChecked: false,
                      rank: 0,
	            },

                    { uuid: "6",
	              txt: "Census needs to know head count for safety, education, healthcare",
                      isChecked: false,
                      rank: 0,
	            },

                    { uuid: "7",
	              txt: "Constitution says 'persons' not citizens; try to count legals and illegals",
                      isChecked: false,
                      rank: 0,
	            },
                ]
            }
        })


    let doRank = (uuid, action) => {
        log.debug("<FlashSelectList>: doRank(): uuid =", uuid)

        let checksCount =  (_.filter(statements, ["isChecked", true])).length
        let clickedStatement = _.find(statements, ["uuid", uuid])
        
        log.debug("<FlashSelectList>: doRank(): clickedStatement =", clickedStatement)
        log.debug("<FlashSelectList>: doRank(): clickedStatement.rank =", clickedStatement.rank)

        
        if(clickedStatement.txt === null || (clickedStatement.txt === "" && clickedStatement.rank === 0)) {
            // do nothing 'cause there is no text
        } else if(clickedStatement.isChecked === false || !clickedStatement.rank || clickedStatement.rank === 0) {
            if(action === "delete") {
                log.debug("<FlashSelectList>: doRank(): deleting unchecked")
            } else {
                log.debug("<FlashSelectList>: doRank(): new check")
                // new check
                clickedStatement.isChecked = true
                clickedStatement.rank = ++checksCount
            }
        } else if(action === "delete" || (clickedStatement.rank === 1) || (clickedStatement.txt === "")) {
            log.debug("<FlashSelectList>: doRank(): delete here")
            // "delete" and re-rank
            // also "delete" if text is empy
            clickedStatement.isChecked = false
            checksCount--
            clickedStatement.rank = 0

            log.debug("<FlashSelectList>: doRank(): DELETE: clickedStatement.rank = ", clickedStatement.rank)
            
            // re-rank other ranked statements starting with 1
            let otherStatements = _.filter(statements, s => {
                return s.uuid !== uuid && s.rank !== 0
            })

            log.debug("<FlashSelectList>: doRank(): DELETE: otherStatements = ", otherStatements)
            // clear out all the unchecked items
            _.map(otherStatements, (s) => {
                if(s.isChecked === false) s.rank = 0
            })

            otherStatements = _.filter(otherStatements, s => {
                return s.uuid !== uuid && s.rank !== 0
            })

            let sortedStatements = _.sortBy(otherStatements, ["rank"])

            let newRank = 1
            _.map(sortedStatements, sortedStatement => {
                sortedStatement.rank = newRank++
            })
            setStatements(statements) // have to update it here
            
        } else if(clickedStatement.rank !== 1) {
            log.debug("<FlashSelectList>: doRank(): decrease")
            // decrease rank and re-order
            clickedStatement.rank--

            // re-order other ranked statements
            let otherStatements = _.filter(statements, s => {
                return s.uuid !== uuid && s.rank !== 0
            })

            let sortedStatements = _.sortBy(otherStatements, ["rank"])

            _.map(sortedStatements, sortedStatement => {
                if(sortedStatement.rank === clickedStatement.rank)
                    sortedStatement.rank++
            })
        }

        log.debug("<FlashSelectList>: doRank(): after main logic")
        
        onChange(_.cloneDeep(statements)) // pass it up so we can save it in parent
    }

    let handleRankClick = uuid => event => {
        log.debug("handleRankClick(): uuid =", uuid)
        log.debug("handleRankClick(): event =", event)
        if(event && event === "delete") {
            doRank(uuid, "delete")
        } else {
            doRank(uuid, "decrease")
        }
    }

    let handleSelectClick = uuid => event => {
        log.debug("handleSelectClick(): uuid =", uuid)
        log.debug("handleSelectClick(): event =", event)
        let clickedStatement = _.find(statements, ["uuid", uuid])
        log.debug("<FlashSelectList>: handleSelectClick(): clickedStatement =", clickedStatement)
        if(clickedStatement.isChecked) {
            clickedStatement.isChecked = false
        } else {
            clickedStatement.isChecked = true
        }

        onChange(_.cloneDeep(statements)) // pass it up so we can save it in parent
    }


    let handleCustomChange = uuid => event => {
        log.debug("<FlashSelectList>: handleCustomChange(): uuid = ", uuid)
        log.debug("<FlashSelectList>: handleCustomChange(): event.target.value = ", event.target.value)
        // length limit
        if(event.target.value.length > 100) return
        
        let changedStatement = _.find(statements, ["uuid", uuid])
        
        changedStatement.txt = event.target.value
        if(changedStatement.txt === "") {
            log.debug("<FlashSelectList>: handleCustomChange(): trigger delete")
            setStatements(_.cloneDeep(statements)) // redraw this component
            doRank(changedStatement.uuid, "change")
        }
        
        onChange(statements) // pass it up so we can save it in parent
    }
    
    // eslint-disable-next-line
    const classes = {
        ...useDefaultStyles(),
        ...className,
    }

    return (
	<div>
          {_.map(statements, statement => {
              /*
              return (
                  <FlashRankCard key={statement.uuid}
                                 text={statement.txt}
                                 isChecked={statement.isChecked}
                                 statement={statement}
                                 onRankClick={handleRankClick(statement.uuid)}
                                 onCustomChange={handleCustomChange(statement.uuid)}/>
              )
*/
              return (
                  <FlashSwipeItem key={statement.uuid} onSwipe={handleRankClick(statement.uuid)}>
                      <FlashSelectCard text={statement.txt}
                                     isChecked={statement.isChecked}
                                     statement={statement}
                  //                                     onRankClick={handleRankClick(statement.uuid)}
                                       onRankClick={handleSelectClick(statement.uuid)}
                                     onCustomChange={handleCustomChange(statement.uuid)}/>
                  </FlashSwipeItem>
              )
          })}
        </div>
    )
}

export default FlashSelectList
